var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"current-page":_vm.page,"isCheckInputBox":false,"loading":_vm.loading,"search-config":_vm.searchConfig,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total},on:{"onChangePage":_vm.onCurrentChange,"onHandle":_vm.tableHandle,"onReset":_vm.onReset,"onSearch":_vm.onSearch,"onExportData":_vm.derived}})
}
var staticRenderFns = []

export { render, staticRenderFns }